<template>
  <div class="md-layout md-alignment-center container">
    <div class="md-layout-item">
      <md-field>
        <label for="first-name">Search for error codes</label>
        <md-input ref="input" name="error-code" id="error-code" :value="value" autocomplete="off" />
        <md-icon>search</md-icon>
      </md-field>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "SearchBar",
  props: { value: String },
  mounted() {
    setTimeout(() => {
      this.$refs.input.$el.focus();
    }, 200);
  }
};
</script>

<style scoped>
.md-layout-item {
  height: 62px;
}
</style>